<div class="flex flex-col w-full gap-1">
    <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>
    <p-datepicker
        [(ngModel)]="value"
        [dateFormat]="dateFormat"
        [showIcon]="true"
        (onSelect)="changeValue($event)"
        [disabled]="isReadOnly"
        [showTime]="showTime"
        appendTo="body"
        styleClass="[&_.p-datepicker-dropdown]:bg-primary! [&_.p-datepicker-dropdown]:border-primary! hover:[&_.p-datepicker-dropdown]:bg-primary-hover! [&_.p-datepicker-dropdown]:transition-colors max-h-8"
        panelStyleClass="[&_.p-datepicker-day-selected]:bg-gray-800! [&_.p-datepicker-day-selected]:text-white!"
    >
        <ng-template #triggericon>
            <i class="pi pi-calendar text-white! bg-transparent!"></i>
        </ng-template>
    </p-datepicker>
</div>
